
import axios from "axios";
import { set } from "lodash";
class MeApi {
    constructor() {

        this.client = axios.create({baseURL: "https://" +
                window.location.host + import.meta.env.VITE_API_PATH + "/me", headers: {"X-Requested-With": "XMLHttpRequest"}});
    }

    get(query) {
        let config = {};
        if (query.authIncludes && query.authIncludes.length) {
            config = set(config, "params.include", query.authIncludes.join());
        }

        return this.client.get(null, config);
    }
}

export default new MeApi();
